import ConditionalRender from '@/components/common/ConditionalRender';
import { MenuItemProps } from '@/types/props/components';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { Badge, ListGroup } from 'react-bootstrap';
import stylesConstants from '@/constants/styles.constants';
import DefaultButton from '@/components/common/default/DefaultButton';
import { useAnalytics } from '@/hooks/useAnalytics';
import useEvents from '@/hooks/useEvents';
import { useRouter } from 'next/router';

export default function MenuItem({
  href,
  badgeCount,
  icon,
  pathname,
  mainText,
  asAnchor,
}: MenuItemProps) {
  const router = useRouter();
  const { getPageType } = useAnalytics();
  const { fireWishlistButtonClickEvent, firePortfolioButtonClickEvent } = useEvents('', []);

  const handleClickToPortfolio = () => {
    firePortfolioButtonClickEvent({
      page_type: getPageType(),
    });
    router.push('/dashboard/portfolio');
  };

  const handleClickToWishlist = () => {
    fireWishlistButtonClickEvent({
      page_type: getPageType(),
    });
    router.push('/dashboard/wishlist');
  };

  const defaultListItemClass = stylesConstants.header.menuLinks.defaultLiClass;
  const listItemActiveClass = stylesConstants.header.menuLinks.liClassActive;
  const listItemInactiveClass = stylesConstants.header.menuLinks.liClassInactive;
  const mainSectionClass = stylesConstants.header.menuLinks.mainSectionClass;

  if (href === '/dashboard/wishlist' || href === '/dashboard/portfolio') {
    return (
      <ListGroup.Item
        as={DefaultButton}
        onClick={href === '/dashboard/portfolio' ? handleClickToPortfolio : handleClickToWishlist}
        className={clsx(defaultListItemClass, {
          [`${listItemActiveClass}`]: href === pathname,
          [`${listItemInactiveClass}`]: href !== pathname,
        })}
      >
        <div className={mainSectionClass}>
          <Image src={icon} width={24} height={24} alt={mainText} className="me-2" />
          <div className="tw-w-full">
            <span className="tw-whitespace-nowrap">{mainText}</span>
          </div>
        </div>
        <ConditionalRender condition={Boolean(badgeCount && badgeCount > 0)}>
          <Badge bg="primary" pill>
            {badgeCount}
          </Badge>
        </ConditionalRender>
      </ListGroup.Item>
    );
  }

  return (
    <ListGroup.Item
      as={asAnchor ? 'a' : Link}
      href={href}
      className={clsx(defaultListItemClass, {
        [`${listItemActiveClass}`]: href === pathname,
        [`${listItemInactiveClass}`]: href !== pathname,
      })}
    >
      <div className={mainSectionClass}>
        <Image src={icon} width={24} height={24} alt={mainText} className="me-2" />
        <div className="tw-w-full">
          <span>{mainText}</span>
        </div>
      </div>
      <ConditionalRender condition={Boolean(badgeCount && badgeCount > 0)}>
        <Badge bg="primary" pill>
          {badgeCount}
        </Badge>
      </ConditionalRender>
    </ListGroup.Item>
  );
}
